<template>
  <w-vue-select
    label-field="name"
    value-field="name"
    :model="schoolModel.schoolName"
    :values="options"
    :ajax="!isSecretary"
    :taggable="!isSecretary"
    @input="updateSchoolData"
    @search="search"
  />
</template>

<script>
import components from '@witkac/bootstrap4-components/src/components/formComponents';

import { schoolPickerChildsOnlyMixin } from '@/mixins/document/schoolPickerChildsOnly';
import { schoolPickerSecretaryMixin } from '@/mixins/schoolPickerSecretary';

// @vuese
// Wybierak szkoły do prezydenckich
// @group Forms
export default {
  components,
  mixins: [schoolPickerSecretaryMixin, schoolPickerChildsOnlyMixin]
};
</script>
